import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'loyaltic-rewards-list',
  templateUrl: './rewards-list.component.html',
  styleUrls: ['./rewards-list.component.scss']
})
export class RewardsListComponent implements OnInit {
  userId = '';
  userType = '';
  rewards = [];
  orderSize: any[] = [];
  results:any ;
  notifyingRewards = {};
  culture = '';
  isLoggedIn = false;
  currentPage = '';
  rewardCarouselIndexes = {};
  notifyToggleSaving: { [rewardPartitionKey: string]: boolean } = {};

  @ViewChild('captureAddress', { static: false }) captureAddressPopUpRef: any;
  @ViewChild('rewardDetailsModal', { static: false }) rewardDetailsModalRef: any;
  public modalRef!: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'modal-lg modal-order modal-dialog-centered',
  };

  rewardDetails: any;
  selectedReward: any;

  constructor(private coreService: CoreService, private authService: AuthService,
    private modalService: BsModalService, private translate: TranslateService, private toast: ToastrService,
    private router: Router, private gaService: GaService) {
    this.userId = authService.getUserId();
    this.userType = authService.getUserType();
    this.culture = translate.getDefaultLang();
    this.isLoggedIn = authService.IsLoggedIn()
  }

  ngOnInit() {
    this.getRewards();
    this.currentPage = this.router.url;
    //console.log(this.currentPage);
  }

  getRewards() {
    this.coreService.getRewards(this.culture, this.userId).then((response: any) => {
      this.results = response.result;
      this.rewards = response.result.rewards;
      this.orderSize = response.result.rewardSizes;

      this.rewards.map((reward:any) => {
        if (this.hasMultiplesizes(reward.partitionKey)) {
          reward.selectedSize = '';
        }
      })

      // console.log(this.rewards);
      //this.gaService.emitEvent('Rewards_Ordered', this.userType);
    });
  }

  getSizeValue(partitionKey:string, selectedSize:string) {
    if (selectedSize === '') {
      let rewardLeft = 0;
      let Sizes = this.orderSize.filter((size:any) => size.rewardPK === partitionKey)[0].sizes;
      Sizes.map((size:any) => {
        rewardLeft = rewardLeft + size.rewardLeft;
      })
      return rewardLeft;
    } else {
      let Sizes = this.orderSize.filter((size:any) => size.rewardPK === partitionKey)[0].sizes;
      return Sizes.filter((size:any) => size.size === selectedSize)[0] ? Sizes.filter((size:any) => size.size === selectedSize)[0].rewardLeft : 0;
    }
   
  }

   isNotifyToggleSaving(rewardPartitionKey: string) {
    return !!this.notifyToggleSaving[rewardPartitionKey];
  }
  onNotifyToggle(rewardPartitionKey: string, event: Event, rewardMappingIndex: number) {
    const checkbox = event.target as HTMLInputElement;
    const nextIsNotified = checkbox.checked;
    const rewardMapping = this.results.rewardCSSMappings[rewardMappingIndex];
    const previousIsNotified = rewardMapping.isUserNotified;
    rewardMapping.isUserNotified = nextIsNotified;
    this.notifyToggleSaving[rewardPartitionKey] = true;
    this.coreService.updateRewardNotification(this.userId, rewardPartitionKey, nextIsNotified)
      .then((response: any) => {
        if (response && typeof response.isUserNotified === 'boolean') {
          rewardMapping.isUserNotified = response.isUserNotified;
          checkbox.checked = response.isUserNotified;
        }
        if (response && response.messageKey) {
          this.toast.success(this.translate.instant('' + response.messageKey), '');
        }
      })
      .catch(() => {
        rewardMapping.isUserNotified = previousIsNotified;
        checkbox.checked = previousIsNotified;
      })
      .then(() => {
        this.notifyToggleSaving[rewardPartitionKey] = false;
      });
  }

  hasSize(sizeInput:string, sizeArray:any) {
    return sizeArray.filter((size:any) => size.size === sizeInput).length > 0;
  }

  hasMultiplesizes(partitionKey:string) {
    return this.orderSize.filter((size:any) => size.rewardPK === partitionKey).length > 0;
  }

  getRewardSizes(partitionKey:string) {
    return this.orderSize.filter((size:any) => size.rewardPK === partitionKey)[0].sizes;
  }

  getClassDetail(reward:any) {
    let todayDate = new Date();
    let parsedDate = new Date(Date.UTC(
      todayDate.getFullYear(),
      todayDate.getMonth(),
      todayDate.getDate(),
      todayDate.getHours(),
      todayDate.getMinutes(),
      todayDate.getSeconds()
    ));

    let rewardDate=  new Date(reward.activeTo);
    let parsedRewardDate= new Date(Date.UTC(
      rewardDate.getFullYear(),
      rewardDate.getMonth(),
      rewardDate.getDate(),
      rewardDate.getHours(),
      rewardDate.getMinutes(),
      rewardDate.getSeconds()
    ));

    let rewardDateFrom = new Date(reward.activeFrom);
    let parsedRewardDateFrom = new Date(Date.UTC(
      rewardDateFrom.getFullYear(),
      rewardDateFrom.getMonth(),
      rewardDateFrom.getDate(),
      rewardDateFrom.getHours(),
      rewardDateFrom.getMinutes(),
      rewardDateFrom.getSeconds()
    ));
    
    if (parsedDate > parsedRewardDate || parsedDate< parsedRewardDateFrom) {
      return 'inactive';
    } else {
      return 'active'
    }

  }

  onRedeemClick(reward:any) {
    this.rewardDetails = reward;
    this.modalRef = this.modalService.show(this.captureAddressPopUpRef, this.popupConfig);
  }

  openRewardDetails(reward:any) {
    this.selectedReward = reward;
    this.modalRef = this.modalService.show(this.rewardDetailsModalRef, {
      class: 'modal-dialog-centered'
    });
  }

  getRewardImages(reward:any) {
    const images = [
      { url: reward && reward.mainImageUrl, label: 'Main image' },
      { url: reward && reward.partnerLogo, label: 'Partner logo' },
      { url: reward && reward.smallImageUrl, label: 'Small image' },
      { url: reward && reward.smallImageOverlayUrl, label: 'Small image overlay' }
    ].filter((image) => image.url);

    return images.length ? images : [
      { url: 'assets/images/reward-placeholder.svg', label: 'Reward placeholder' }
    ];
  }

  getRewardCarouselIndex(rewardIndex, rewardImages) {
    const selectedIndex = this.rewardCarouselIndexes[rewardIndex] || 0;
    return selectedIndex < rewardImages.length ? selectedIndex : 0;
  }

  setRewardCarouselIndex(event, rewardIndex, slideIndex) {
    event.stopPropagation();
    this.rewardCarouselIndexes[rewardIndex] = slideIndex;
  }

  showPreviousRewardImage(event, rewardIndex, rewardImages) {
    event.stopPropagation();
    const currentIndex = this.getRewardCarouselIndex(rewardIndex, rewardImages);
    this.rewardCarouselIndexes[rewardIndex] = currentIndex === 0 ? rewardImages.length - 1 : currentIndex - 1;
  }

  showNextRewardImage(event, rewardIndex, rewardImages) {
    event.stopPropagation();
    const currentIndex = this.getRewardCarouselIndex(rewardIndex, rewardImages);
    this.rewardCarouselIndexes[rewardIndex] = currentIndex === rewardImages.length - 1 ? 0 : currentIndex + 1;
  }

  NotifyuserClick(RewardPartitionkey, index) {
    this.notifyingRewards[RewardPartitionkey] = true;

    this.coreService.Notifyuser(this.userId, RewardPartitionkey)
      .then((response: any) => {
        const messageKey = response.messageKey;
        this.toast.success(this.translate.instant('' + messageKey), '');

        if (this.results && this.results.rewardCSSMappings && this.results.rewardCSSMappings[index]) {
          this.results.rewardCSSMappings[index].isUserNotified = true;
        }
      })
      .finally(() => {
        delete this.notifyingRewards[RewardPartitionkey];
      });
  }


  onHideCaptureDetails() {
    this.modalRef.hide();
  }

}
